module.exports = __webpack_public_path__ + "static/media/NotoSerif-Regular.d1c72e0e.ttf";